import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import usePostHogFeatureFlag from 'hooks/usePostHogFeatureFlag';
import SSRSafeElement from 'commons/SSRSafeElement';
import Link from 'components/consumer/Link';
import useKeyboardControlForDropdown from 'hooks/useKeyboardControlForDropdown';
import IconInspirationUnderline from 'components/icons/IconInspirationUnderline';
const DesktopNavCategoryItem = t0 => {
  const $ = _c(45);
  const {
    containerRef,
    color: t1,
    id,
    label,
    isOpen,
    setIsLinkHovered,
    url
  } = t0;
  const color = t1 === undefined ? "content" : t1;
  const toggleRef = useRef(null);
  const hideSaleDropDown = usePostHogFeatureFlag("show-sale-dropdown-menu-item");
  let t2;
  if ($[0] !== hideSaleDropDown || $[1] !== id || $[2] !== setIsLinkHovered) {
    t2 = () => {
      if (id === "sale") {
        if (hideSaleDropDown) {
          setIsLinkHovered(id, true);
        }
      } else {
        setIsLinkHovered(id, true);
      }
    };
    $[0] = hideSaleDropDown;
    $[1] = id;
    $[2] = setIsLinkHovered;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleOptionOpenHoverAndClick = t2;
  let t3;
  if ($[4] !== id) {
    t3 = () => document.getElementById(`DesktopNavCategory--${id}`);
    $[4] = id;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== handleOptionOpenHoverAndClick) {
    t4 = () => {
      handleOptionOpenHoverAndClick();
    };
    $[6] = handleOptionOpenHoverAndClick;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== id || $[9] !== setIsLinkHovered) {
    t5 = () => {
      setIsLinkHovered(id, false);
    };
    $[8] = id;
    $[9] = setIsLinkHovered;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== containerRef || $[12] !== isOpen || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = {
      isOpen,
      isParentPopup: true,
      getPopupContainerElement: t3,
      toggleContainerRef: containerRef,
      toggleRef,
      open: t4,
      close: t5
    };
    $[11] = containerRef;
    $[12] = isOpen;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  useKeyboardControlForDropdown(t6);
  const isColorRed = color === "red";
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = classNames("group/DesktopNavCategoryItem-link text-sm font-bold inline-block min-h-[55px] px-2 py-0 relative no-underline", "xl:text-base xl:font-bold", "focus-visible:outline-offset-[-2px]");
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== handleOptionOpenHoverAndClick) {
    t8 = () => {
      handleOptionOpenHoverAndClick();
    };
    $[18] = handleOptionOpenHoverAndClick;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== id || $[21] !== setIsLinkHovered) {
    t9 = () => {
      setIsLinkHovered(id, false);
    };
    $[20] = id;
    $[21] = setIsLinkHovered;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const t10 = !isColorRed;
  const t11 = isOpen && !isColorRed;
  const t12 = !isColorRed;
  const t13 = !isColorRed;
  const t14 = isOpen && isColorRed;
  let t15;
  if ($[23] !== isColorRed || $[24] !== t10 || $[25] !== t11 || $[26] !== t12 || $[27] !== t13 || $[28] !== t14) {
    t15 = classNames("items-center [border-bottom:1px_solid_#fff] inline-flex min-h-[55px] text-center", {
      "text-gray": t10,
      "[border-bottom:1px_solid_#107c8c]": t11,
      "group-focus-visible/DesktopNavCategoryItem-link:[border-bottom:1px_solid_#107c8c] group-focus-visible/DesktopNavCategoryItem-link:text-brand": t12,
      "group-hover/DesktopNavCategoryItem-link:[border-bottom:1px_solid_#107c8c] group-hover/DesktopNavCategoryItem-link:text-brand": t13,
      "text-red": isColorRed,
      "[border-bottom:1px_solid_#b85455]": t14,
      "group-focus-visible/DesktopNavCategoryItem-link:[border-bottom:1px_solid_#b85455] group-focus-visible/DesktopNavCategoryItem-link:text-red": isColorRed,
      "group-hover/DesktopNavCategoryItem-link:[border-bottom:1px_solid_#b85455] group-hover/DesktopNavCategoryItem-link:text-red": isColorRed
    });
    $[23] = isColorRed;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== label || $[31] !== t15) {
    t16 = <span className={t15}>{label}</span>;
    $[30] = label;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== id) {
    t17 = id === "inspiration" && <IconInspirationUnderline className="left-[7px] absolute top-10 w-[72px]" />;
    $[33] = id;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== id || $[36] !== t16 || $[37] !== t17 || $[38] !== t8 || $[39] !== t9 || $[40] !== url) {
    t18 = <Link to={url} className={t7} onMouseEnter={t8} onMouseLeave={t9} data-xc={id} ref={toggleRef}>{t16}{t17}</Link>;
    $[35] = id;
    $[36] = t16;
    $[37] = t17;
    $[38] = t8;
    $[39] = t9;
    $[40] = url;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== id || $[43] !== t18) {
    t19 = <li key={id} className="list-none">{t18}</li>;
    $[42] = id;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  return t19;
};
DesktopNavCategoryItem.propTypes = {
  color: PropTypes.oneOf(['content', 'red']),
  containerRef: PropTypes.shape({
    current: PropTypes.instanceOf(SSRSafeElement)
  }),
  id: PropTypes.string,
  isOpen: PropTypes.bool,
  label: PropTypes.string,
  url: PropTypes.string,
  setIsLinkHovered: PropTypes.func
};
export default DesktopNavCategoryItem;